import React, { useState } from "react";

interface TeachingFocusesSectionProps {
  teachingFocuses: string[];
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => void;
  compact?: boolean;
}

export const TeachingFocusesSection: React.FC<TeachingFocusesSectionProps> = ({
  teachingFocuses,
  onChange,
  compact = false,
}) => {
  const [input, setInput] = useState("");

  const emitChange = (value: string[]) => {
    onChange({ target: { name: "teachingFocuses", value } } as any);
  };

  const addFocus = (value: string) => {
    const focus = value.trim();
    if (!focus || teachingFocuses.includes(focus)) return;
    emitChange([...teachingFocuses, focus]);
    setInput("");
  };

  const removeFocus = (focus: string) => {
    emitChange(teachingFocuses.filter((item) => item !== focus));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "," || e.key === "Enter") {
      e.preventDefault();
      addFocus(input);
    }
    if (e.key === "Backspace" && !input && teachingFocuses.length) {
      removeFocus(teachingFocuses[teachingFocuses.length - 1]);
    }
  };

  return (
    <div className={compact ? "space-y-1" : "space-y-3"}>
      {!compact && (
        <h3 className="text-sm font-medium text-[#1F1109]">Teaching focuses</h3>
      )}
      <div>
        <label
          className={
            compact
              ? "block text-xs font-medium text-[#3D2817] mb-1"
              : "block text-sm font-medium text-[#3D2817] mb-1.5 tracking-[0.02em]"
          }
        >
          Topics and skills you teach
        </label>
        <div
          className={`flex items-center gap-1.5 flex-wrap bg-white border border-[#1F1109]/[0.18] focus-within:border-[#B8893D] transition-colors ${
            compact ? "rounded-md px-2 py-1.5" : "rounded-lg px-2.5 py-2"
          }`}
        >
          {teachingFocuses.map((focus) => (
            <span
              key={focus}
              className="flex items-center gap-1 bg-[#B8893D]/[0.14] text-[#6B4F1F] px-2.5 py-1 rounded-full text-xs whitespace-nowrap"
            >
              {focus}
              <button
                type="button"
                onClick={() => removeFocus(focus)}
                className="text-xs text-[#6B4F1F] hover:text-[#7A2E2E] transition-colors ml-0.5"
              >
                ×
              </button>
            </span>
          ))}
          <input
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={
              teachingFocuses.length === 0
                ? "Type a focus area and press comma"
                : ""
            }
            className={`flex-1 border-none outline-none p-1 min-w-[120px] bg-transparent placeholder:text-[#9C8366] ${
              compact ? "text-xs text-[#1F1109]" : "text-sm text-[#1F1109]"
            }`}
          />
        </div>
      </div>
    </div>
  );
};
